/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createPublicUserDetailFieldHook, createPublicUserHook } from '../../core/factories/createPublicUserHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetUserRow } from '../openapi-types.gen.js';
import { type useGetUserArgs, useGetUserSpec, useGetUserRealtime } from '../specs/users.spec.gen.js';

export type { GetUserRow } from '../openapi-types.gen.js';
export type { useGetUserArgs } from '../specs/users.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): identifier, walletPubkeys.
 */
export const useGetUser = createPublicUserHook(useGetUserSpec, useGetUserRealtime);


/**
 * Per-field subscription hook for the \`useGetUser\` cache entry.
 * Pass the SAME args as the parent hook (same queryKey → same cache). Returns the named field's value; only the call site
 * re-renders when that field changes (TanStack tracked-properties +
 * per-component `select`).
 *
 *     function Title({ pubkey }) {
 *       const value = useGetUserField({ pubkey }, 'title');
 *       return <h3>{value}</h3>;
 *     }
 */
export const useGetUserField = createPublicUserDetailFieldHook(useGetUserSpec);

/**
 * Hover/intent prefetch companion for `useGetUser`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetUser();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetUser = createPrefetchHook(useGetUserSpec);
